/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Example_Spills_Last_MonthInputs */

const en_us2_chat_example_spills_last_month = /** @type {(inputs: Chat_Example_Spills_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many overflows did we have last month?`)
};

const en_gb2_chat_example_spills_last_month = /** @type {(inputs: Chat_Example_Spills_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many spills did we have last month?`)
};

/**
* | output |
* | --- |
* | "How many overflows did we have last month?" |
*
* @param {Chat_Example_Spills_Last_MonthInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const chat_example_spills_last_month = /** @type {((inputs?: Chat_Example_Spills_Last_MonthInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Example_Spills_Last_MonthInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_chat_example_spills_last_month(inputs)
	return en_us2_chat_example_spills_last_month(inputs)
});